export const SetPolicyModal = (open) => {
  return {
    type: "SET_POLICY_MODAL",
    policyModalOpen: open,
  };
};
export default SetPolicyModal;
